export default __webpack_public_path__ + "static/media/knight_of_wands.bfa0bcd7.png";